import {createSlice} from '@reduxjs/toolkit';
import {httpDelete, httpGet, httpPost} from '../../../util/Rest';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  billingMaintenanceStatus: null,
  billingMaintenanceData: [],
  getBillingData: [],
  findBillingByIdData: [],
  getBillingDropdown: [],
  postSuccessMsg: null,
  isPostLoading: false,
  getBillingDropdownData: [],
  billingMappingSaveData: [],
  allIndicatorNumbersAndNames: [],
  billingMapData: [],
  getServiceClientData: [],
  rowData: [],
  corporateNameData: [],
};

const slice = createSlice({
  name: 'billingIndicator',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getBillingData: (state, action) => {
      state.getBillingIndicatorsData = action.payload;
    },
    getBillingIndicatorsData: (state, action) => {
      state.getBillingDropdown = action.payload;
    },
    getBillingIndicatorsById: (state, action) => {
      state.findBillingByIdData = action.payload;
    },
    findBillingData: (state, action) => {
      state.getBillingData = action.payload;
    },
    postBillingData: (state, action) => {
      state.isLoading = true;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
      state.billingMaintenanceStatus = action.payload?.status;
    },
    postIndicatorData: (state, action) => {
      state.isPostLoading = true;
      state.postSuccessMsg = action.payload;
    },
    setRowData: (state, action) => {
      state.rowData = action.payload;
      state.successMsg = action.payload?.response;
    },
    billingMappingData: (state, action) => {
      state.errorMsg = null;
      state.successMsg = action.payload.message;
      state.billingMappingData = action.payload;
    },
    getBillingMaintenanceData: (state, action) => {
      state.errorMsg = null;
      state.billingMaintenanceData = action.payload;
      // state.billingMaintenanceStatus = action.payload;
    },
    getBillingMapData: (state, action) => {
      // state.isLoading = true;
      state.errorMsg = null;
      state.billingMapData = action.payload;
      // state.billingMaintenanceStatus = action.payload;
    },
    fetchserviceClientType: (state, action) => {
      state.getServiceClientData = action.payload;
      state.isLoading = false;
    },
    billingDropdownData: (state, action) => {
      state.getBillingDropdownData = action.payload;
      state.isLoading = false;
    },
    saveBillingMapping: (state, action) => {
      state.successMsg = action.payload.response;
      state.status = action.payload.status;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    getAllNumbersAndDisplayName: (state, action) => {
      state.allIndicatorNumbersAndNames = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetData: (state) => {
      state.isLoading = false;
      state.billingMaintenanceStatus = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.status = null;
      state.rowData = [];
      state.billingMaintenanceData = [];
    },
    resetAssignCompany: (state) => {
      state.getServiceClientData = [];
      state.corporateNameData = [];
    },
    resetGetServiceClientData: (state) => {
      state.getServiceClientData = [];
    },
    resetCorporateNameData: (state) => {
      state.corporateNameData = [];
    },
    getCorporateNameData: (state, action) => {
      state.corporateNameData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    deleteBillingIndicator: (state, action) => {
      state.status = action?.payload?.status;
      state.successMsg = action?.payload?.response;
      state.isLoading = false;
    },
    resetBillingIndicatorData: (state) => {
      state.postSuccessMsg = null;
      state.isPostLoading = false;
      state.findBillingByIdData = [];
      state.billingMapData = [];
      state.allIndicatorNumbersAndNames = [];
    },
    resetLoader: (state) => {
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  fetchError,
  resetData,
  resetLoader,
  getBillingIndicatorsData,
  postBillingData,
  resetGetServiceClientData,
  resetCorporateNameData,
  getBillingMapData,
  saveBillingMapping,
  getBillingMaintenanceData,
  findBillingData,
  getCorporateNameData,
  postIndicatorData,
  setRowData,
  getBillingIndicatorsById,
  resetBillingIndicatorData,
  billingMappingData,
  fetchserviceClientType,
  billingDropdownData,
  deleteBillingIndicator,
  getAllNumbersAndDisplayName,
  resetAssignCompany,
} = slice.actions;

export const getBillingIndicators = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/find/mbidetails/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getBillingIndicatorsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchBillingIndicators = (billingIndicatorId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/find/accountbi/${billingIndicatorId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getBillingIndicatorsById(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const findAllBillingIndicators = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/findall/bi`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(findBillingData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postBillingMaintenance = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`billing/save/mstbie`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postBillingData(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const postBillingIndicator = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`billing/save/accountbi`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postIndicatorData(data?.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const getBillingMaintenance = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/find/mstbie/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getBillingMaintenanceData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchBillingMapData = (clientBillingId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/find/billing/indicator/${clientBillingId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getBillingMapData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchAllBillingIndicatorNumbersAndNames = () => {
  return (dispatch) => {
    httpGet(`billing/find/all/mstbi`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllNumbersAndDisplayName(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetBillingDataData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const fetchServiceClientDropDownData = (siteId, corporateId, companyId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/findall/serviceclient/${siteId}/${corporateId}/${companyId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchserviceClientType(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postBillingMapping = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`billing/save/mstbi`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(saveBillingMapping(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const billingMappingDetails = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/find/all/clientbi`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(billingMappingData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchBillingIndicatorsDropdownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`billing/find/all/mstbi`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(billingDropdownData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetBillingIndicator = () => {
  return (dispatch) => {
    dispatch(resetBillingIndicatorData());
  };
};

export const fetchCorporateNameDataBI = (companyId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`company/findall/companyidandname/${companyId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCorporateNameData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const deleteBillingIndicatorData = (accNum, billingNum) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpDelete(`billing/delete/billingIndicator/${accNum}/${billingNum}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteBillingIndicator(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetCorparateName = () => {
  return (dispatch) => {
    dispatch(resetCorporateNameData());
  };
};
